import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class VixxoApiService {
  // Resolve HTTP using the constructor
  constructor(private httpClient: HttpClient, private router: Router) {}

  public postRequest(endpoint: string, params: Object = {}) {
    if (!endpoint) {
      return;
    }
    return this.httpClient.post(endpoint, params).catch(this.handleError);
  }

  /**
   * Error Handler
   * @param error
   * @returns {any}
   */
  private handleError(error: Response | any) {
    if (error.status === 401) {
      this.router.navigate(['access-unauthorized']);
      return of([]);
    } else {
      return Observable.throwError(error);
    }
  }
}
